/**
 * FAQ Accordion
 * Handles expand/collapse for accordion items.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion-trigger');
    if (!trigger) return;

    var item = trigger.closest('.accordion-item');
    if (!item) return;

    var isOpen = item.classList.contains('is-open');

    // Close all siblings in the same parent
    var parent = item.parentElement;
    if (parent) {
      parent.querySelectorAll('.accordion-item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Toggle current
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
  });
})();
